import ApiGenericServicesData from "service/ApiGenericServicesData";
import { codificarValorSeguro } from "util/codificarValorSeguro";

export default class ReportesGenerales extends ApiGenericServicesData {
    constructor() {
        super("reportesGenerales");
    }

    async getInformeDetalladoAfRenun(data) {
        const dataSegura = await codificarValorSeguro(data);
        return this.customPOST("afiliadosORenunciasDetallado/", dataSegura);
    }

    async getReporteComite(data) {
        const dataSegura = await codificarValorSeguro(data);
        return this.customPOST("reporteComitesEjecutivo/", dataSegura);
    }

    async getReporteOPASAM(data) {
        const dataSegura = await codificarValorSeguro(data);
        return this.customPOST("reporteOPASAM/", dataSegura);
    }

}